export const devicesWidths = {
    mobile: {
        min: 360,
        max: 600,
    },
    desktop: {
        min: 1000,
        max: 1200,
    },
};
export const defaultHeight = 50;
